import { Separator } from '@/components/ui/separator'
import OverviewTable from './(components)/overview-table'

const ShortlistPage = () => {
  return (
    <div className='p-4 space-y-4 h-full flex flex-col justify-between overflow-auto'>
      <header>
        <h1 className='text-3xl font-bold'>Shortlist</h1>
      </header>

      <Separator />

      <OverviewTable />
    </div>
  )
}

export default ShortlistPage